export default "__VITE_ASSET__CKbqoF$X__"